import React, { ReactElement } from "react";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
// import { useLayoutContext } from "../AppContextProvider/LayoutContextProvider";
import { useLocaleContext } from "../AppContextProvider/LocaleContextProvider";
import AppLocale from "@lib/services/localization";
import { useTypedSelector } from "@lib/redux";
import { GlobalStyles } from "@app/.core/theme/GlobalStyle";
import { Normalize } from "styled-normalize";
import { getTheme, mapToAntdTheme } from "@app/.core/theme";

interface AppThemeProviderProps {
  children: ReactElement;
}

const AppThemeProvider: React.FC<AppThemeProviderProps> = (props) => {
  // const { direction } = useLayoutContext();
  const { locale } = useLocaleContext();
  const { isDark } = useTypedSelector((state) => state.settings);

  const { antLocale } = AppLocale[locale.locale];
  const themeMode = isDark ? "dark" : "light";
  const theme = getTheme(themeMode);

  // useEffect(() => {
  //   document.body.setAttribute("dir", direction);
  // }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider
        // direction={direction as any}
        locale={antLocale}
        theme={mapToAntdTheme(themeMode)}
      >
        <Normalize />
        <GlobalStyles theme={theme} />
        {props.children}
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default React.memo(AppThemeProvider);
